module.exports = __webpack_public_path__ + "static/media/search-icon.ff818bc5.svg";